import { on } from "@ngrx/store";

import { cloneDeep } from "lodash";

import { BrandingActions } from "../../../state/branding.store";

import { JobTagActions } from "./job-tags.actions";
import { JobTagsState } from "./job-tags.state";


export const jobTagsReducers = [
  on(
    JobTagActions.jobTagsLoaded,
    (state: JobTagsState, { tags }): JobTagsState => {
      return {
        ...state,
        tags,
        tagsModified: false,
      };
    },
  ),
  on(
    JobTagActions.searchTagsSuccess,
    (state: JobTagsState, { tagSuggestions }): JobTagsState => {
      return {
        ...state,
        tagSuggestions,
      };
    },
  ),
  on(
    JobTagActions.fetchDefaultTagsSuccess,
    (state: JobTagsState, { defaultTags }): JobTagsState => {
      return {
        ...state,
        defaultTags,
      };
    },
  ),
  on(
    JobTagActions.tagSelected,
    (state: JobTagsState, { tag }): JobTagsState => {

      // Filter out any other tags with the same category
      const updatedTags = state.tags
        .filter((t) => t.id ===  tag.id || !t.category || t.category !== tag.category);

      // Add the new tag if it's not already in the array
      if (!updatedTags.some((t) => t.id === tag.id)) {
        updatedTags.push(tag);
      }

      return {
        ...state,
        tags: updatedTags,
        tagsModified: true,
      };
    },
  ),
  on(
    JobTagActions.tagUnselected,
    (state: JobTagsState, { tag }): JobTagsState => {
      return {
        ...state,
        tags: state.tags.filter((t) => t.id !== tag.id),
        tagsModified: true,
      };
    },
  ),
  on(
    JobTagActions.setTagsSuccess,
    JobTagActions.setTagsError,
    (state: JobTagsState): JobTagsState => {
      return {
        ...state,
        tagsModified: false,
      };
    },
  ),
  on(
    JobTagActions.tagAutocompleteSearchFired,
    (state: JobTagsState, { query }): JobTagsState => {

      // Searching, do not show
      if (query?.trim()?.length > 0) return state;

      return {
        ...state,
        tagSuggestions: cloneDeep(state.defaultTags),
      };
    },
  ),
  on(
    BrandingActions.brandingUpdated,
    (state: JobTagsState): JobTagsState => {

      return {
        ...state,
        defaultTags: [],
      };
    },
  ),
];
